<script setup>
import { Link } from '@inertiajs/inertia-vue3'
const props = defineProps(['item'])
const offerLabel = status => ({
    active: 'Publicada',
    scheduled: 'Programada',
    paused: 'Pausada',
    sold_out: 'Agotada',
    expired: 'Vencida',
    draft: 'Borrador',
}[status] || 'Sin publicar')

</script>

<template>
    <div class="relative flex justify-end w-full">
        <Link :href="'/portfolio/harvest/'+item.id" class="w-full my-2">
        <div class="flex w-full px-5 mx-1 transition-all shadow-md md:px-1 md:h-20 rounded-3xl sm:mx-0 bg-light_yellow hover:shadow-lg hover:bg-yellow">
            <img
                class="hidden object-cover w-10 h-10 m-5 bg-white border-2 rounded-full border-enriqueto_green md:block"
                :src="item.fruit.image"
                alt=""
            />
            <div class="grid w-full grid-cols-3 gap-3 pb-3 align-middle transition-all md:pb-0 md:gap-8 md:grid-cols-5 rounded-3xl">
                <div class="flex col-span-2 pt-3 md:pt-7 md:col-span-1">
                    <img
                        class="block object-cover m-1 bg-white border-2 rounded-full w-14 h-14 border-enriqueto_green md:hidden"
                        :src="item.fruit.image"
                        alt=""
                    />
                    <div>
                        <p class="m-4 font-bold text-enriqueto_green md:m-0"><strong>{{item.name}}</strong></p>
                        <p class="mx-4 -mt-3 text-xs text-gray md:hidden">{{ item.fruit.name }} · {{ offerLabel(item.offer?.effective_status) }}</p>
                    </div>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="text-enriqueto_green">{{ item.fruit.name }}</p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold text-enriqueto_green md:hidden">Tamaño</p>
                    <p class="text-enriqueto_green">
                        {{item.has_trees ? `${item.size} árboles` : `${item.size} ${item.area_unit === 'ha' ? 'ha' : 'm²'}`}}
                    </p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <p class="font-bold text-enriqueto_green md:hidden">Ubicación</p>
                    <p class="text-enriqueto_green">{{item.lat}}/{{item.lon}}</p>
                </div>
                <div class="hidden md:pt-7 md:block">
                    <span class="px-3 py-1 text-xs font-bold bg-white rounded-full text-enriqueto_green">{{ offerLabel(item.offer?.effective_status) }}</span>
                </div>
            </div>

        </div>
        </Link>
    </div>
</template>
